import React, { ReactElement, useEffect } from "react";
import { CopyIcon } from "../Icon";
import {
  Box,
  HStack,
  IconButton,
  useClipboard,
  useToast,
} from "@chakra-ui/react";

interface TextCopyProps {
  textCopy: string;
  children: ReactElement | string;
  description?: string;
}

const TextCopy: React.FC<TextCopyProps> = ({
  textCopy,
  children,
  description = "Text is copied!",
}) => {
  const toast = useToast();
  const { onCopy, hasCopied } = useClipboard(textCopy);

  useEffect(() => {
    if (hasCopied) {
      toast({
        description,
      });
    }
  }, [hasCopied, toast]);

  return (
    <HStack spacing="10px">
      <Box as="span">{children}</Box>
      <IconButton
        minWidth="none"
        aria-label={`Copy ${textCopy}`}
        variant="link"
        type="button"
        title="Salin"
        onClick={onCopy}
        icon={<CopyIcon boxSize="16px" />}
      />
    </HStack>
  );
};

export default TextCopy;
